import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BannerSize } from "web/script/utils/app-banner-campaign";

export interface AppDownloadBannerSlice {
    isVisible: boolean;
    bannerSize: BannerSize;
    desktopBannerVisible: boolean;
}

const appDownloadBanner = createSlice({
    name: "appDownloadBanner",
    initialState: {
        isVisible: Boolean(false),
        bannerSize: BannerSize.None,
        desktopBannerVisible: false,
    } as AppDownloadBannerSlice,
    reducers: {
        bannerHidden(state): void {
            state.isVisible = false;
            state.bannerSize = BannerSize.None;
        },
        bannerVisible(state): void {
            state.isVisible = true;
        },
        setBannerSize(state, action: PayloadAction<BannerSize>): void {
            state.bannerSize = action.payload;
        },
        setDesktopBannerVisible(state, action: PayloadAction<boolean>): void {
            state.desktopBannerVisible = action.payload;
        },
    },
});

export const {
    bannerHidden,
    bannerVisible,
    setBannerSize,
    setDesktopBannerVisible,
} = appDownloadBanner.actions;
export default appDownloadBanner.reducer;
